import React from 'react';
import Teamwork from '../../Elements/Logo/TEAMWORK.png'
import { useMediaQuery } from '../../Hooks/mediaQuery'

export const SplashScreen = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 400px)' })

    const imgStyle = {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxHeight: '90vh',
        width: isMobile ? '100%' : 'auto'
    }

    return <img src={Teamwork} style={imgStyle} alt='Teamwork' />
}